<template>
  <div class="container-fluid px-5">
    <!-- Header -->
    <div class="text-center mb-4 mt-3">
      <h1 class="title-page mb-1">Today's Status</h1>
      <p class="sub-title">{{ todayLabel }}</p>
    </div>
    

    <!-- Grid -->
    <div class="row">
      <!-- Card -->
      <div
        v-for="item in cardStatus"
        :key="item.title"
        class="col-12 col-md-4 mb-4"
      >
        <div class="status-card p-3 rounded-4 h-100">
          <div class="icon-wrapper mb-2">
            <i
              :data-feather="item.icon"
              class="icon"
            ></i>
          </div>

          <h1 class="fw-bold mb-1">{{ item.value }}</h1>
          <p class="mb-0 ">{{ item.title }}</p>

          <small
            v-if="item.sub"
            class="text-muted d-block mt-1"
          >
            {{ item.sub }}
          </small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {axiosGet} from "../../../common/Helper/AxiosHelper";
import {PUBLIC_DASHBOARD} from "../../../tenant/Config/ApiUrl";
import CoreLibrary from "../../../core/helpers/CoreLibrary";
import feather from 'feather-icons'
export default {
  name: 'TodayStatus',
  extends: CoreLibrary,
  data() {
    return {
      todayLabel: 'Loading...',
      cardStatus : [
        { title: 'Present', value: 0, icon: 'user-check' },
        { title: 'Absent', value: 0, icon: 'user-x' },
        { title: 'Running Late', value: 0, icon: 'clock' },
        { title: 'Avg Arrival Today', value: '00:00 AM', icon: 'clock' },
        { title: 'Best On-Time Streak', value: '0 Days', icon: 'zap', sub: '' },
        { title: 'Most Consistent', value: '±0 min', icon: 'target', sub: '' },
      ],
      timerInterval: null,
    };
  },
  methods: {
    getData() {
      axiosGet(`${PUBLIC_DASHBOARD}/today-status`).then(({data}) => {
        this.todayLabel = data.date_label || this.todayLabel;
        this.cardStatus = [
          { title: 'Present', value: data.present, icon: 'user-check' },
          { title: 'Absent', value: data.absent, icon: 'user-x' },
          { title: 'Running Late', value: data.running_late, icon: 'clock' },
          { title: 'Avg Arrival Today', value: data.avg_arrival, icon: 'clock' },
          { title: 'Best On-Time Streak', value: `${data.streak.days} Days`, icon: 'zap', sub: data.streak?.name },
          { title: 'Most Consistent', value: `±${data.consistency ? data.consistency ?.std_dev_min : '0'} min`, icon: 'target', sub: data.consistency ? data.consistency.name : '0' },
        ];
      }).catch(error => {
        console.error('Error fetching today status:', error);
      });
    }
  },
  watch: {
    cardStatus: {
      handler() {
        this.$nextTick().then(() => {
          feather.replace();
        });
      },
      deep: true,
    },
  },
  created() {
    this.getData();
  },
  mounted() {
    this.$nextTick(() => {
      feather.replace();
    });
    this.timerInterval = setInterval(this.getData, 60 * 1000); // Update every minute
  },
  beforeDestroy() {
    clearInterval(this.timerInterval);
  },
  beforeUnmount() {
    clearInterval(this.timerInterval); // Clear the interval when the component is unmounted
  }
}
</script>

<style scoped>
.container-fluid {
  overflow: hidden;
}

/* New Styles */
.title-page {
    font-size: 1.6rem; /* text-5xl */
    line-height: 1; 
    font-weight: 1000; /* font-bold */
    color: rgb(17, 24, 39); /* text-gray-900 */
    letter-spacing: -0.025em; /* tracking-tight */
} 
.sub-title {
    font-size: 1rem; /* text-2xl (24px) */
    line-height: 2rem; 
    color: rgb(107, 114, 128); /* text-gray-500 */
}
.section-title {
    font-size: 1.875rem;                                                                                                                                
    line-height: 2.25rem; 
    font-weight: 700; 
}

.status-card {
  border: 1px solid #eee;
  margin-bottom: 10px;
  text-align: center;
  background-color: #fff;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

/* Card hover */
.status-card:hover {
  transform: translateY(-3px);
  background-color: #b1122a;
  color: white;
}

/* ICON STYLE */
.icon {
  width: 40px;
  height: 40px;
  color: #b1122a;
  transition: color 0.3s ease;
}

/* GROUP HOVER */
.status-card:hover .icon {
  color: white;
}

/* Text tweaks */
.status-card p {
  opacity: 0.85;
  font-size: 1.3rem;
}
.fw-bold{
    font-weight: 800;
    font-size: 2rem;
}

/* =================== RESPONSIVE =================== */

/* ≤1200px - slightly smaller padding */
@media (max-width: 1200px) {
  .container-fluid {
    padding-left: 30px;
    padding-right: 30px;
  }
}

/* ≤992px - tablet */
@media (max-width: 992px) {
  .status-card {
    padding: 30px;
  }

  .icon {
    width: 40px;
    height: 40px;
  }

  h1.fw-bold {
    font-size: 2.2rem;
  }
}

/* ≤768px - small tablet / large phone */
@media (max-width: 768px) {
  .container-fluid {
    padding-left: 20px;
    padding-right: 20px;
  }

  h1.fw-bold {
    font-size: 1.8rem;
  }

  .status-card {
    padding: 25px;
  }

  .icon {
    width: 36px;
    height: 36px;
  }
}

/* ≤576px - mobile */
@media (max-width: 576px) {
  .container-fluid {
    padding-left: 1rem !important;
    padding-right: 1rem !important;
  }

  h1.fw-bold {
    font-size: 1.6rem;
  }

  p.text-muted {
    font-size: 0.9rem;
  }

  .status-card {
    padding: 20px;
  }

  .icon {
    width: 32px;
    height: 32px;
  }

   .status-card h1 {
    font-size: 1.6rem;
  }
}
</style>
